export default function getBusinessDomainName(businessDoc) {
  const customDomain = businessDoc.get("customDomain");
  if (customDomain && typeof customDomain === "string") {
    return customDomain;
  } else {
    return businessDoc.get("domain");
  }
}
